import React, { useEffect, useRef, useState } from 'react';
import { IWebsiteWidgetConfig } from '../../interfaces/website_widget';
import {
    WEBSITE_WIDGET_URL,
    WEBSITE_WIDGET_ID,
    WEBSITE_WIDGET_SCRIPT_ID
} from '../../config/keys';

type Props = {
    config: IWebsiteWidgetConfig;
    refreshPreview: boolean;
    setRefreshPreview(refresh: boolean): void;
    script: HTMLScriptElement;
    setScript(script: HTMLScriptElement): void;
};

export default function WebsiteWidgetPreview({
    config,
    refreshPreview,
    setRefreshPreview,
    setScript }: Props) {
    const [srcDoc, setSrcDoc] = useState<string>('');

    const preview = useRef<HTMLIFrameElement>(null);

    const createWidgetScript = () => {
        if (document.getElementById(WEBSITE_WIDGET_SCRIPT_ID)) {
            document.getElementById(WEBSITE_WIDGET_SCRIPT_ID).remove();
        }

        const script = document.createElement('script');
        script.src = WEBSITE_WIDGET_URL;
        script.id = WEBSITE_WIDGET_SCRIPT_ID;

        for (const i in config) {
            const item: any = config[i as keyof IWebsiteWidgetConfig];
            script.setAttribute(`data-${i}`, item);
        }

        setScript(script);
        setSrcDoc(`<div id="${WEBSITE_WIDGET_ID}"></div> ${script.outerHTML}`);
    };

    useEffect(() => {
        createWidgetScript();

        if (refreshPreview) {
            setRefreshPreview(false);
        }
    }, [refreshPreview]);

    return (
        <div className="ring-2 ring-inset ring-brand_secondary rounded-md sm:rounded-lg relative overflow-hidden flex h-full">
            <div className="p-3 sm:p-4 xl:p-5 flex w-full flex-col">
                <iframe
                    ref={preview}
                    srcDoc={srcDoc}
                    className="flex-grow border-none -m-2"
                ></iframe>
            </div>
        </div>
    );
}
